import { Box, Button, Typography } from "@mui/material";
import React, { useState, useRef, useEffect } from "react";
import "./index.scss";
import {
  getCountries,
  getCountryCallingCode,
  isValidPhoneNumber,
} from "react-phone-number-input";
import flags from "react-phone-number-input/flags";
import InputBase from "@mui/material/InputBase";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { styled } from "@mui/material/styles";
import "./index.scss";
import "react-phone-number-input/style.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useRequestOTP, useSubmitOTP } from "hooks/auth";
import { getRefreshTokenCookie, setRefreshTokenCookie } from "lib/Storage";
import useInfoContext from "hooks/useInfoContext";
import LoadingButton from "@mui/lab/LoadingButton";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "left",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "left",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 4,
    minWidth: 160,
    backgroundColor: theme.palette.background.main,
    border: `1px solid ${theme.palette.button.main}`,
    color: "white",
    marginTop: 1,
    "& .MuiMenu-list": {
      padding: 0,
      margin: 0,
    },
    "& .MuiMenuItem-root": {
      display: "flex",
      alignItems: "center",
      color: theme.palette.white.main,
      fontFamily: "IRANSANSWEB",
      "&:hover": {
        backgroundColor: "#535353",
      },
      "&.active": {
        color: theme.palette.button.main,
      },

      ".item-flag": {
        width: "40%",
        display: "flex",
        alignItems: "center",
        backgroundColor: theme.palette.fieldFill.main,
      },
      ".item-name": {
        width: "100%",
        padding: "0 10%",
        display: "flex",
        alignItems: "center",
        fontSize: "1rem",
      },
      ".item-code": {
        width: "20%",
        display: "flex",
        alignItems: "center",
        marginRight: "8%",
        textAlign: "right",
        fontSize: "1rem",
      },
    },
  },
}));

const Login = () => {
  const [loginState, setLoginState] = useState("");
  const [resendTime, setResendTime] = useState(180);
  const [country, setCountry] = useState("IR");
  const [menuStatus, setMenuStatus] = useState(null);
  const [alert, setAlert] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [valueInput, setValueInput] = useState("");
  const [error, setError] = useState("");
  const [otpValues, setOtpValues] = useState(new Array(5).fill(""));
  const open = Boolean(menuStatus);
  const navigate = useNavigate();
  const { mutate: sendPhoneNumber, isLoading } = useRequestOTP();
  const { mutate: verifyCode, isLoading: isLoadingVerify } = useSubmitOTP();
  const { setIsLogin, isLogin } = useInfoContext();
  const [searchParams] = useSearchParams();
  const refUrl = searchParams.get("ref");

  // function for phone number
  const handleClick = (event) => {
    setMenuStatus(event.currentTarget);
  };

  const handleClose = () => {
    setMenuStatus(null);
  };

  const handleSelect = (country) => {
    setCountry(country);
    handleClose();
  };

  const handleRedirectAndAddToken = () => {
    const token = getRefreshTokenCookie();

    if (!!refUrl) {
      const url = new URL(refUrl);
      url.searchParams.set("refreshtoken", token);
      url.searchParams.delete("ref");
      window.location.href = url.toString();
      return;
    }
    navigate("/");
  };

  useEffect(() => {
    if (isLogin) {
      handleRedirectAndAddToken();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLogin]);

  const countries = getCountries();
  const getCountryCode = (i) => getCountryCallingCode(i);
  const getFlag = (i) => (flags[i] ? flags[i]({ title: i }) : null);
  useEffect(() => {
    const codeCountry = getCountryCode(country);
    let formatedNumber = valueInput.replace(/[^0-9]/g, "");

    if (formatedNumber.charAt(0) === "0") {
      formatedNumber = formatedNumber.slice(1);
    }

    formatedNumber = `+${codeCountry}${formatedNumber}`;

    setPhoneNumber(formatedNumber);
    setAlert("");
  }, [valueInput, country]);

  const handleContinue = () => {
    if (isValidPhoneNumber(phoneNumber)) {
      setAlert("");
      sendPhoneNumber(
        { phoneNumber, refId: searchParams.get("r") },
        {
          onSuccess: (data) => {
            if (data?.status === "OK") {
              setLoginState("otp");
            } else if (data?.status === "ALREADY REQUESTED!") {
              setAlert("از اس ام اس قبلیتون کمتر از ۳ دقیقه گذشته است");
            }
          },
        }
      );
    } else if (phoneNumber === "" || valueInput === "") {
      setAlert("پر کردن این فیلدها اجباریست.");
    } else {
      setAlert("شماره وارد شده صحیح نمیباشد.");
    }
  };

  // function for otp
  const minutes = Math.floor(resendTime / 60);
  let seconds = resendTime % 60;
  seconds = seconds < 10 ? "0" + seconds : seconds;
  const timeString = `${minutes}:${seconds}`;

  useEffect(() => {
    if (loginState === "otp") {
      const intervalId = setInterval(() => {
        setResendTime((prevTime) => (prevTime > 0 ? prevTime - 1 : 0));
      }, 1000);
      return () => clearInterval(intervalId);
    }
  }, [loginState]);

  const editPhone = () => {
    setLoginState("");
  };

  const inputRefs = useRef([]);
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && e.target.value === "" && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleSendOtp = (otpCode) => {
    if (otpCode.length < 5) {
      setError("لطفا تمام کد ارسال را وارد کنید.");
    } else {
      verifyCode(otpCode, {
        onSuccess: (data) => {
          if (data?.status === "OK") {
            setRefreshTokenCookie(data.refreshToken);
            setIsLogin(true);
            switch (data.onStage) {
              case "new":
                navigate(`/card-issuance?ref=${refUrl}`);
                break;
              default:
            }
          } else if (data?.status === "Invalid Pin!") {
            setError("کد وارد شده صحیح نمیباشد.");
          }
        },
        onError: (err) => {
          console.log("error in inside onError", err);
        },
      });
    }
  };

  const handleOtpChange = (e, index) => {
    const { value } = e.target;
    if (/^[0-9]?$/.test(value)) {
      const newOtpValues = [...otpValues];
      newOtpValues[index] = value;
      setOtpValues(newOtpValues);

      if (value.length >= 1 && index < inputRefs.current.length - 1) {
        inputRefs.current[index + 1].focus();
      }
      const otpCode = newOtpValues.join("");
      if (otpCode.length === 5) {
        handleSendOtp(otpCode);
      }
      setError("");
    }
  };

  const handleResend = () => {
    sendPhoneNumber(phoneNumber, {
      onSuccess: (data) => {
        if (data?.status === "OK") {
          setAlert("");
          setResendTime(180);
        }
      },
    });
  };

  return (
    <Box className="login-page-wrapper">
      {loginState === "" && (
        <>
          <Box className="child-box">
            <Box className="main-wrapper">
              <Typography variant="h1" className="top-text">
                به آکادمی آن خوش اومدی!
              </Typography>
              <Box className={`phone-number-wrapper`}>
                <InputBase
                  className={`main-input ${alert ? "error" : ""}`}
                  sx={{
                    fontFamily: "bahnschrift",
                  }}
                  value={valueInput}
                  onChange={(e) => {
                    setValueInput(e.target.value);
                  }}
                  type="number"
                  inputMode="numeric"
                  autoFocus
                  disableUnderline
                />
                <Button
                  className={`country-code-button ${open ? " open-menu" : ""}`}
                  id="basic-button"
                  aria-controls={open ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                  fullWidth={true}
                >
                  <div className="country-code-box">
                    <span className="code">{getCountryCode(country)}+</span>
                  </div>
                </Button>
                <StyledMenu
                  id="basic-menu"
                  anchorEl={menuStatus}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                  PaperProps={{
                    style: {
                      maxHeight: "38%",
                    },
                  }}
                >
                  {countries.map((item, i) => (
                    <MenuItem
                      key={i}
                      onClick={() => handleSelect(item)}
                      className={item === country ? "active" : ""}
                    >
                      <div className="item-flag">{getFlag(item)}</div>
                      <span className="item-name">{item}</span>
                      <span className="item-code">+{getCountryCode(item)}</span>
                    </MenuItem>
                  ))}
                </StyledMenu>

                <Box className="input-alert">
                  {alert && <span>{alert}</span>}
                </Box>
              </Box>
            </Box>
          </Box>
          <Box className="bottom-bar-login">
            <LoadingButton
              loading={isLoading}
              variant="contained"
              className="continue"
              onClick={handleContinue}
              loadingPosition="end"
              sx={{ fontFamily: "IRANSANSWEB" }}
            >
              ادامه
            </LoadingButton>
          </Box>
        </>
      )}

      {loginState === "otp" && (
        <>
          <Box className="child-box">
            <Box className="main-wrapper main-login">
              <Typography variant="h6" className="phone-send">
                کد تایید به شماره "{valueInput}" ارسال شد. کد تایید خود را وارد
                کنید.
                <span className="edit-phone" onClick={editPhone}>
                  ویرایش شماره
                </span>
              </Typography>
              <Box className="otp-wrapper">
                {Array.from({ length: 5 }).map((_, index) => (
                  <input
                    key={index}
                    type="number"
                    inputMode="numeric"
                    maxLength="1"
                    ref={(el) => (inputRefs.current[index] = el)}
                    value={otpValues[index]}
                    onChange={(e) => handleOtpChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    style={{ outline: "none" }}
                    className={error ? "error" : ""}
                    autoFocus={!index}
                  />
                ))}
              </Box>
              <Box className="bottom-input">
                <Box>
                  <Box className="input-alert">
                    {error && <span>{error}</span>}
                  </Box>
                </Box>
                <Box>{timeString !== "0:00" && timeString}</Box>
              </Box>
              <Box className="parent-resend">
                {timeString === "0:00" && (
                  <>
                    کد تایید دریافت نکردید؟
                    <span className="resend-otp" onClick={handleResend}>
                      ارسال مجدد
                    </span>
                  </>
                )}
              </Box>
            </Box>
          </Box>
          <Box className="bottom-bar-login">
            <LoadingButton
              loading={isLoadingVerify}
              variant="contained"
              className="continue"
              onClick={handleSendOtp}
              sx={{ fontFamily: "IRANSANSWEB" }}
            >
              ادامه
            </LoadingButton>
          </Box>
        </>
      )}
    </Box>
  );
};

export default Login;
